import React from 'react';
import { Redirect, Route } from 'react-router-dom';

function getPrivateRoute(props, rest, Component) {
  if (rest.user && rest.user.date_register_finished) {
    return <Component {...props} {...rest} />;
  } else if (
    rest.user &&
    !rest.user.date_register_finished &&
    props.location.pathname === '/register'
  ) {
    return <Component {...props} {...rest} />;
  } else if (
    rest.user &&
    !rest.user.date_register_finished &&
    props.location.pathname !== '/register'
  ) {
    return <Redirect to={`/register`} />;
  }

  return <Redirect to={`/login/?redirect=${props.location.pathname}`} />;
}

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => getPrivateRoute(props, rest, Component)}
  />
);

export default PrivateRoute;
